<div>{{data || 'N/A'}}</div>
